import React from 'react';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { CreditCard } from 'lucide-react';
import { Control } from "react-hook-form";

interface PaymentLinkFieldProps {
  control: Control<any>;
  isLoading: boolean;
  isVisible: boolean;
}

const PaymentLinkField: React.FC<PaymentLinkFieldProps> = ({
  control,
  isLoading,
  isVisible
}) => {
  if (!isVisible) return null;

  return (
    <FormField
      control={control}
      name="paymentUrl"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="flex items-center gap-2">
            <CreditCard className="w-4 h-4" />
            Payment Link (Optional)
          </FormLabel>
          <FormControl>
            <Input 
              placeholder="https://payment.example.com/quote-payment" 
              {...field} 
              disabled={isLoading}
              type="url"
            />
          </FormControl>
          <FormDescription>
            Provide a direct payment link for this quote. This will be shown when the quote is accepted.
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default PaymentLinkField;